/* eslint-disable no-param-reassign */
function sliceTextOnButton() {
  const buttonText = document.querySelectorAll(".main-button span");

  if (buttonText) {
    buttonText.forEach((span) => {
      const maxLength = 35;
      const originalText = span.textContent;

      if (originalText.length > maxLength) {
        span.textContent = "Скачать";
      }
    });
  }
}

export default sliceTextOnButton;